<template>
  <div class="carousel-box">
    <div
      v-if="modalShow"
      class="carousel-modal"
      :class="{'modal-shadow': modalShadow}"
    >
      <slot name="modal-layer" />
    </div>
    <el-carousel
      :arrow="arrow"
      :height="height"
      class="animate__animated animate__fadeIn animate__fast index-carousel"
      :class="{'item-to-top': itemTop}"
      :indicator-position="indicatorPosition"
    >
      <el-carousel-item
        v-for="(img, index) in imgs"
        :key="index"
      >
        <div class="carousel-pic-box">
          <img
            class="carousel-pic"
            :src="img.src"
          >
        </div>
      </el-carousel-item>
      <slot name="carousel-items" />
    </el-carousel>
  </div>
</template>

<script>
export default {
  name: 'SegCarousel',
  props: {
    modalShow: {
      type: Boolean,
      default() {
        return true
      }
    },
    height: {
      type: String,
      default() {
        return '930px';
      },
    },
    imgs: {
      type: Array,
      default() {
        return [];
      },
    },
    modalShadow: {
      type: Boolean,
      default() {
        return true;
      },
    },
    arrow: {
      type: String,
      default() {
        return 'never';
      },
    },
    itemTop: {
      type: Boolean,
      default() {
        return true;
      },
    },
    indicatorPosition: {
      type: String,
      default() {
        return 'inside';
      },
    },
  },
};
</script>

<style scoped lang="less">
    @deep: ~">>>";
    .carousel-box {
        overflow: hidden;
        position: relative;
        @{deep} .index-carousel {
          .el-carousel__item {
            img {
              width: 100%;
              object-fit: cover;
            }
          }
            .el-carousel__button {
                height: 8px;
                width: 8px;
                border-radius: 4px;
            }
        }
    }

    .carousel-modal {
        width: 100%;
        height: 100%;
        position: absolute;
        z-index: 3;
        text-align: center;
    }

    .carousel-pic-box{
      display: flex;
      height: 100%;
      justify-content: space-around;
    }

    .item-to-top{
      z-index: 4;
    }

  .modal-shadow{
    background: rgba(0, 0, 0, 0.25);
  }
</style>
